// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"697":"6bbeb597","829":"adfacd48","892":"adfacd48"}[chunkId] + ".chunk.css";
};